import { Button, Divider, Form, FormInstance, Input, message, Modal, Select, Space, Switch, Table } from "antd";
import Password from "antd/lib/input/Password";
import { useEffect, useRef, useState } from "react";
import Server from "../../../server/Server";
import URL from "../../../server/URL";
import TextArea from "antd/lib/input/TextArea";

const InquiryMemberEdit = (props: any) => {
    const formRef = useRef<FormInstance>(null);
    const { ...rest } = props;
    const [salesData, setSalesData] = useState<any>([]);
    const [companyData, setCompanyData] = useState<any>([]);
    const [memberType, setMemberType] = useState<any>(null);
    const [memberID, setMemberID] = useState<any>(null);

    useEffect(() => {
        if (props.isOpen) {
            setMemberID(props.memberID ?? null);
            loadSales();
        } else {
            setMemberID(null);
            setData(null);
        }
    }, [props.isOpen])

    useEffect(() => {
        if (memberID) {
            getData();
        } else {
            setData(null);
        }
    }, [memberID])

    const getData = () => {
        var request = {
            memberID: memberID
        }
        Server.Post(URL.InquiryMember.GetInquiryMember, request, false).then((response: any) => {
            if (response.isSuccess) {
                setData(response);
            }
        })
    }

    const setData = (record: any) => {
        formRef.current?.resetFields();
        if (record) {
            formRef.current?.setFieldsValue({
                ...record,
                memberType: { value: record.memberTypeEnum, label: record.memberType },
                company: { value: record.companyID, label: record.companyName },
                sales: { value: record.salesID, label: record.salesName },
            })
            setMemberType({ value: record.memberTypeEnum, label: record.memberType })
        } else {
            setMemberType({ value: 99, label: '普通会员' })
        }
    }

    const onChangeMember=()=>{
        if (memberType) {
            switch (memberType?.value) {
                case 0:
                    formRef.current?.setFieldValue('sales', null);
                    formRef.current?.setFieldValue('company', null);
                    break;
                case 1:
                    loadSales();
                    formRef.current?.setFieldValue('company', null);
                    break;
                case 2:
                    loadCompanys();
                    formRef.current?.setFieldValue('sales', null);
                    break;
            }
        }
    }

    const loadSales = () => {
        Server.Post(URL.Sales.GetSalesOptions, {}, false).then((response: any) => {
            if (response.isSuccess) {
                setSalesData(response.data);
            }
        })
    }

    const loadCompanys = () => {
        Server.Post(URL.Company.GetCompanyOptions, {}, false).then((response: any) => {
            if (response.isSuccess) {
                setCompanyData(response.data);
            }
        })
    }

    const handleCancel = () => {
        rest.setIsOpen(false);
    }

    const handleSave = () => {
        formRef.current?.validateFields().then((values => {
            var params = {
                memberID: memberID,
                ...values,
                memberTypeEnum: values?.memberType?.value,
                memberType: values?.memberType?.label,
                salesID: values.sales?.value ?? null,
                salesName: values.sales?.label ?? null,
                companyID: values.company?.value ?? null,
                companyName: values.company?.label ?? null
            };
            Server.Post(URL.InquiryMember.SaveInquiryMember, params).then((response: any) => {
                if (response.isSuccess) {
                    message.success('保存成功');
                    rest.setIsOpen(false);
                    rest.loadData();
                } else {
                    message.warn(response.returnMsg);
                }
            })
        }));
    }

    const filterOption = (input: string, option?: { label: string; value: string }) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

    return <Modal title={"开通会员"} width={600} open={rest.isOpen} onCancel={handleCancel}
        maskClosable={false}
        bodyStyle={{ padding: 0, margin: 8 }}
        footer={
            <Space>
                <Button onClick={handleSave} type='primary'>保存</Button>
                <Button onClick={handleCancel}>关闭</Button>
            </Space>
        }>
        <Form ref={formRef}
            labelCol={{
                xs: { span: 24 },
                sm: { span: 4 }
            }} wrapperCol={{
                xs: { span: 24 },
                sm: { span: 20 }
            }}>
            <Form.Item style={{ marginBottom: '5px' }} label={'会员类型'} name={'memberType'}
                initialValue={{ value: 99, label: '普通会员' }}
                rules={[{ required: true, message: '请输入用户密码' }]}>
                <Select labelInValue options={[
                    { value: 99, label: '普通会员' },
                    { value: 2, label: '代理会员' },
                    { value: 3, label: '保司会员' }
                ]} onChange={(e) => {
                    setMemberType(e);
                    onChangeMember();
                }} />
            </Form.Item>
            <Form.Item hidden={memberType?.value != 2} style={{ marginBottom: '5px' }} label={'业务员'}
                name={'sales'} initialValue={null}
                rules={[{ required: memberType?.value == 2, message: '请选择业务员' }]}>
                <Select labelInValue
                    allowClear
                    placeholder={'选择业务员'}
                    style={{ width: '100%' }}
                    options={salesData}
                    showSearch
                    onChange={(e: any) => {
                        if (e) {
                            var filter = salesData.filter((item: any) => item.value == e.value);
                            if (filter && filter.length > 0) {
                                var sales = JSON.parse(filter[0].data);
                                formRef.current?.setFieldValue('account', sales.Tel);
                                formRef.current?.setFieldValue('name', sales.Name);
                                formRef.current?.setFieldValue('password', '123');
                                formRef.current?.setFieldValue('tel', sales.Tel);
                            }
                        }
                    }}
                    optionFilterProp="children"
                    filterOption={filterOption} />
            </Form.Item>
            <Form.Item hidden={memberType?.value != 3} style={{ marginBottom: '5px' }} label={'保险公司'}
                name={'company'} initialValue={null}
                rules={[{ required: memberType?.value == 3, message: '请选择保险公司' }]}>
                <Select labelInValue
                    allowClear
                    placeholder={'选择保险公司'}
                    style={{ width: '100%' }}
                    options={companyData}
                    showSearch
                    onChange={(e: any) => {
                        if (e) {
                            var filter = companyData.filter((item: any) => item.value == e.value);
                            if (filter && filter.length > 0) {
                                var company = JSON.parse(filter[0].data);
                                formRef.current?.setFieldValue('account', company.Tel);
                                formRef.current?.setFieldValue('name', company.Contact);
                                formRef.current?.setFieldValue('password', '123');
                                formRef.current?.setFieldValue('tel', company.Tel);
                            }
                        }
                    }}
                    optionFilterProp="children"
                    filterOption={filterOption} />
            </Form.Item>
            <Form.Item style={{ marginBottom: '5px' }} label={'会员账号'} name={'account'} initialValue={''} rules={[{ required: true, message: '请输入用户账号' }]}>
                <Input />
            </Form.Item>
            <Form.Item style={{ marginBottom: '5px' }} label={'会员密码'} name={'password'} initialValue={''} rules={[{ required: true, message: '请输入用户密码' }]}>
                <Password />
            </Form.Item>
            <Form.Item style={{ marginBottom: '5px' }} label={'会员名称'} name={'name'} initialValue={''} rules={[{ required: true, message: '请输入用户名称' }]}>
                <Input />
            </Form.Item>
            <Form.Item style={{ marginBottom: '5px' }} label={'手机号码'} name={'tel'} initialValue={''} rules={[{ required: true, pattern: new RegExp(/^((13[0-9])|(14[5,7])|(15[0-3,5-9])|(17[0,3,5-8])|(18[0-9])|166|198|199|(147)|19[0-1])\d{8}$/, 'g'), message: '请输入11位手机号码' }]}>
                <Input />
            </Form.Item>
            <Form.Item style={{ marginBottom: '5px' }} label={'企业名称'} name={'enterpriseName'} initialValue={''}>
                <Input />
            </Form.Item>
            <Form.Item style={{ marginBottom: '5px' }} label={'是否激活'} name={'isActive'} initialValue={true} valuePropName={'checked'}>
                <Switch checked />
            </Form.Item>
            <Form.Item style={{ marginBottom: '5px' }} label={'备注'} name={'remark'} initialValue={''}>
                <TextArea rows={5} maxLength={2000} showCount />
            </Form.Item>
        </Form>
    </Modal>
};
export default InquiryMemberEdit;